<template>
  <div class="container">
    <h1>证书管理</h1>
    
    <div class="button-group">
      <el-button 
        type="primary" 
        icon="el-icon-download" 
        @click="downloadTemplate">
        下载模版
      </el-button>

      <el-button 
        type="success" 
        icon="el-icon-upload" 
        @click="goToImport">
        导入证书
      </el-button>
    </div>

   <el-dialog :title="upload.title"
               :visible.sync="upload.open"
               width="400px"
               append-to-body>
      <el-upload ref="upload"
                 :limit="1"
                 accept=".xlsx, .xls"
                 :action="upload.url"
                 :disabled="upload.isUploading"
                 :on-progress="handleFileUploadProgress"
                 :on-success="handleFileSuccess"
                 :auto-upload="false"
                 drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center"
             slot="tip">
          <span>仅允许导入 xls、xlsx 格式文件。</span>
          <!-- <el-link type="primary"
                   :underline="false"
                   style="font-size: 12px; vertical-align: baseline"
                   @click="down">下载模板</el-link> -->
        </div>
      </el-upload>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "导入证书",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        // 上传的地址
        url: window.glob.baseURL +"/learning/importOtherCert.html",
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    goToImport() {
      this.upload.title = "导入证书";
      this.upload.open = true;
    },
    submitFileForm() {
      this.$refs.upload.submit();
    },
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    handleFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      this.upload.open = false;
      this.$message.success('导入成功');
    },
    down() {
      this.downloadTemplate();
    },
    downloadTemplate() {
      const link = document.createElement('a');
      console.log(window.glob.baseURL,'99000');
      
      link.href = window.glob.baseURL + '/static/imp_other_cert.xls'; 
      link.download = 'imp_other_cert.xls'; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {}
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.button-group {
  margin-top: 50px;
  display: flex;
  gap: 15px; 
  margin-bottom: 20px;
}

</style>